import {Component, h} from "preact";
import {icons} from "../icons";
import styles from "./style.module.scss"
import {ProductFilter} from "../../models/filter";
import {connect} from "redux-zero/preact";
import actions from "../../store/actions";
import {Gender} from "../../models/product";
import Filter from "../filter";
import {i18nService} from "../../services/i18n-service";
import {filterService} from "../../services/filter-service";
import {Collection} from "../../models/collection";

interface Props {
  filters: ProductFilter[];
  gender: Gender;
  headlineKey: string;
  sort?: boolean;
}

interface State {
  isExpanded: boolean;
  filters: ProductFilter[]
}

class FilterGroup extends Component<Props, State> {

  state = {
    isExpanded: true,
    filters: null
  };

  componentDidMount(): void {
    const filtersRequiringTranslations = this.props.filters;
      if (this.props.sort) {
        filtersRequiringTranslations.forEach((filter: ProductFilter) => filter.translation = i18nService.translate(filterService.getTranslationKey(filter, this.props.gender)));

        filtersRequiringTranslations.sort((filterA: ProductFilter, filterB: ProductFilter) => {
          if (filterA.translation > filterB.translation) {return 1}
          else if (filterA.translation < filterB.translation) {return -1}
          else {return 0}
        });
      }
    this.setState({filters: filtersRequiringTranslations});
  }

  componentWillReceiveProps(newProps: Readonly<Props>) {
    const filtersRequiringTranslations = newProps.filters;
    if (newProps.filters !== this.props.filters) {
      if (this.props.sort) {
        filtersRequiringTranslations.forEach((filter: ProductFilter) => filter.translation = i18nService.translate(filterService.getTranslationKey(filter, this.props.gender)));

        filtersRequiringTranslations.sort((filterA: ProductFilter, filterB: ProductFilter) => {
          if (filterA.translation > filterB.translation) {return 1}
          else if (filterA.translation < filterB.translation) {return -1}
          else {return 0}
        });
      }
    }
    this.setState({filters: filtersRequiringTranslations});
  }

  render() {
    if (!this.state.filters) {
      return null;
    }

    return (
        <div class={styles['filter-group-container']}>
          <div class={styles.headline} onClick={this._toggleFilterCategory.bind(this)}>
            {i18nService.translate(this.props.headlineKey)}
            <span>{this.state.isExpanded ? icons.renderMinusIcon() : icons.renderPlusIcon()}</span>
          </div>
          <div class={`${styles['filter-group']} ${this.state.isExpanded ? styles.expanded : ''}`}>
            {this.state.filters.map((filter: ProductFilter) => {
              return <Filter filter={filter}/>
            })}
          </div>
        </div>
    )
  }

  _toggleFilterCategory() {
    this.setState(prevState => {
      return {
        isExpanded: !prevState.isExpanded
      }
    });
  }
}

export default connect(null, actions)(FilterGroup)